import {useContext} from 'react'
import {StripeContext} from './StripeContext'

export const useStripe = () => {
  const contextInstance = useContext(StripeContext)
  if (!contextInstance) throw new Error('Cannot call useStripe() outside of <StripeProvider>')
  return contextInstance
}
